<template>
  <div id="contenedor-eliminar-documento-expediente">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Documento </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el documento? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarDocumentoExpediente"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixExpedientes from '../mixExpedientes';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarDocumentoExpediente',
  mixins: [mixExpedientes],
  props: {
    documentoExpedienteEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
